const HolidayGift = ({ className }: { className?: string }) => (
  <svg
    className={className}
    fill="none"
    height="150"
    viewBox="0 0 151 150"
    width="151"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint0_linear_9_97"
        x1="63.2381"
        x2="87.0375"
        y1="130.055"
        y2="75.0643"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint1_linear_9_97"
        x1="43.5403"
        x2="85.8084"
        y1="123.489"
        y2="76.2962"
      >
        <stop offset="0.239141" stopColor="#FFD43E" />
        <stop offset="1" stopColor="#FF6D4E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint2_linear_9_97"
        x1="55.0306"
        x2="106.737"
        y1="121.847"
        y2="73.8341"
      >
        <stop offset="0.239141" stopColor="#FFD43E" />
        <stop offset="1" stopColor="#FF6D4E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint3_linear_9_97"
        x1="101.736"
        x2="87.1645"
        y1="69.4301"
        y2="53.6635"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint4_linear_9_97"
        x1="67.9254"
        x2="49.2195"
        y1="71.6012"
        y2="51.3576"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint5_linear_9_97"
        x1="86.2926"
        x2="67.6725"
        y1="60.3094"
        y2="40.16"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint6_linear_9_97"
        x1="64.469"
        x2="82.5037"
        y1="75.8857"
        y2="65.5887"
      >
        <stop stopColor="#6E3264" />
        <stop stopColor="#754B7A" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint7_linear_9_97"
        x1="65.2899"
        x2="98.1195"
        y1="84.0933"
        y2="68.089"
      >
        <stop offset="0.239141" stopColor="#FFD43E" />
        <stop offset="1" stopColor="#FF6D4E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint8_linear_9_97"
        x1="38.6158"
        x2="75.5491"
        y1="74.2443"
        y2="65.6266"
      >
        <stop offset="0.239141" stopColor="#FFD43E" />
        <stop offset="0.936607" stopColor="#FF6D4E" />
      </linearGradient>
    </defs>
    <path
      d="M82.5092 124.775V125.726H69.1704V125.165V75.8546V75.392H82.5092V75.5638V124.775Z"
      fill="url(#paint0_linear_9_97)"
    />
    <path
      d="M69.1704 125.164V125.726H47.8402C46.8289 125.726 46.0093 124.907 46.0093 123.902V77.2162C46.0093 76.2115 46.8289 75.3919 47.8402 75.3919H69.1704V125.171V125.164Z"
      fill="url(#paint1_linear_9_97)"
    />
    <path
      d="M105.498 77.2163V123.902C105.498 124.907 104.679 125.726 103.667 125.726H82.509V75.392H103.667C104.679 75.392 105.498 76.2116 105.498 77.2163Z"
      fill="url(#paint2_linear_9_97)"
    />
    <path
      d="M82.509 75.3919H103.667C104.679 75.3919 105.498 76.2115 105.498 77.2162V123.902C105.498 124.907 104.679 125.726 103.667 125.726H47.8334C46.8221 125.726 46.0025 124.907 46.0025 123.902V77.2162C46.0025 76.2115 46.8221 75.3919 47.8334 75.3919H82.509Z"
      stroke="#6E3264"
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth="3"
    />
    <path
      d="M69.1704 75.8546V125.164"
      stroke="#6E3264"
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth="3"
    />
    <path
      d="M82.509 75.5639V124.775"
      stroke="#6E3264"
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth="3"
    />
    <path
      d="M79.0843 62.5023C83.0592 57.7658 88.9148 51.2369 92.0709 49.9576C97.1331 47.9067 102.912 50.3416 104.968 55.3992C106.013 57.9802 105.899 60.7495 104.857 63.1174L82.4759 62.9676L78.847 62.9467C78.9228 62.8046 78.9937 62.6671 79.0645 62.5296C79.0694 62.5251 79.0698 62.5157 79.0843 62.5023Z"
      fill="url(#paint3_linear_9_97)"
    />
    <path
      d="M72.3417 62.4431C72.4244 62.6007 72.4981 62.7487 72.5811 62.8969L69.1301 62.8736L46.5715 62.7261C45.566 60.3432 45.4829 57.5755 46.5706 55.0129C48.691 49.9743 54.4995 47.6206 59.5425 49.7459C62.6758 51.0711 68.4371 57.6543 72.3417 62.4431Z"
      fill="url(#paint4_linear_9_97)"
    />
    <path
      d="M75.8846 36.2057C81.3514 36.2381 85.7553 40.7005 85.7135 46.1669C85.695 49.4965 81.978 57.073 79.0751 62.5018C79.0605 62.5153 79.0556 62.5198 79.0553 62.5291C78.9283 62.6644 78.8152 62.805 78.707 62.9411L72.7119 62.9019C72.5915 62.7522 72.4666 62.5976 72.3417 62.443C69.5067 56.9805 65.9049 49.3643 65.928 46.0395C65.9652 40.5683 70.4227 36.1689 75.8891 36.2106L75.8846 36.2057Z"
      fill="url(#paint5_linear_9_97)"
    />
    <path
      d="M82.476 62.9676L82.4735 63.1499L82.3949 74.5553L82.3899 75.514L69.0534 75.4202L69.0567 74.859L69.1301 63.3506L69.1346 62.8783L72.5857 62.9017L72.712 62.9019L78.7115 62.9459L78.8426 62.9417L82.476 62.9676Z"
      fill="url(#paint6_linear_9_97)"
    />
    <path
      d="M108.041 63.135C109.052 63.1373 109.861 63.9643 109.854 64.9697L109.79 73.8591C109.788 74.8694 108.961 75.6788 107.956 75.6721L82.3808 75.5044L82.3903 74.5505L82.4644 63.1403L82.4621 62.9625L104.843 63.1122L108.032 63.1347L108.041 63.135Z"
      fill="url(#paint7_linear_9_97)"
    />
    <path
      d="M46.5716 62.726L69.1301 62.8734L69.1256 63.3457L69.0523 74.8542L69.0444 75.4105L43.2919 75.2451C42.2816 75.2428 41.4721 74.4159 41.4838 73.406L41.5384 64.5162C41.55 63.5063 42.3725 62.692 43.3779 62.6987L46.5671 62.7212L46.5716 62.726Z"
      fill="url(#paint8_linear_9_97)"
    />
    <path
      d="M104.857 63.1173L108.046 63.1397C109.056 63.142 109.866 63.969 109.859 64.9744L109.795 73.8638C109.793 74.8741 108.966 75.6835 107.96 75.6768L82.3854 75.5091L69.0488 75.4153L43.2962 75.2499C42.286 75.2477 41.4765 74.4207 41.4881 73.4108L41.5428 64.521C41.5544 63.5111 42.3769 62.6968 43.3823 62.7036L46.5715 62.726L69.13 62.8734L72.5811 62.8968L72.7167 62.8974L78.7118 62.9365L78.8474 62.9372L82.4763 62.9582L104.857 63.108L104.857 63.1173Z"
      stroke="#6E3264"
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth="3"
    />
    <path
      d="M69.1301 63.3504L69.0568 74.8589"
      stroke="#6E3264"
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth="3"
    />
    <path
      d="M82.4734 63.1499L82.3947 74.5553"
      stroke="#6E3264"
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth="3"
    />
    <path
      d="M79.0596 62.5342C78.9887 62.6717 78.9178 62.8092 78.8421 62.9512"
      stroke="#6E3264"
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth="3"
    />
    <path
      d="M72.5856 62.9017C72.5025 62.7534 72.4244 62.6006 72.3462 62.4479C69.5111 56.9854 65.9093 49.3692 65.9324 46.0444C65.9696 40.5732 70.4271 36.1737 75.8935 36.2155C81.3603 36.2479 85.7642 40.7102 85.7224 46.1766C85.7038 49.5062 81.9869 57.0828 79.084 62.5115"
      stroke="#6E3264"
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth="3"
    />
    <path
      d="M104.857 63.1174C105.895 60.7446 106.013 57.9802 104.968 55.3992C102.908 50.3367 97.1329 47.9067 92.0708 49.9576C88.9191 51.2417 83.0591 57.7658 79.0842 62.5022C79.0696 62.5157 79.0648 62.5202 79.0644 62.5295C78.9375 62.6649 78.8244 62.8054 78.7161 62.9415"
      stroke="#6E3264"
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth="3"
    />
    <path
      d="M46.576 62.731C45.5659 60.3432 45.4829 57.5755 46.5706 55.0129C48.691 49.9743 54.4995 47.6206 59.5425 49.7459C62.6758 51.0711 68.4371 57.6543 72.3417 62.4431C72.4666 62.5977 72.5964 62.7478 72.7119 62.9021"
      stroke="#6E3264"
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth="3"
    />
  </svg>
)

export default HolidayGift
